import {DataFetcher, useLegacyGrpcRequest} from '@aboutyou/data-fetcher';
import {CheckoutV1_getCustomerLazy} from '@aboutyou/grpc-clients/grips/protos/checkout/checkout_v1.grpc.lazy';
import {GetCustomerResponse} from '@aboutyou/grpc-clients/grips/protos/checkout/checkout_v1.types';
import {UserGenders, useOptionalUser, useUserToken} from '@aboutyou/user';
import React, {useEffect} from 'react';
import {normalizeLegacyCheckoutCustomerData} from '../../features/Authentication/utility/normalizeAuthData';

export const LoadCustomerData = () => {
  return (
    <DataFetcher
      request={useCheckoutCustomerData()}
      View={UpdateUserData}
      Error={null}
    />
  );
};

const UpdateUserData = ({customer}: GetCustomerResponse) => {
  const {updateCache} = useOptionalUser();
  useEffect(() => {
    const customerData = normalizeLegacyCheckoutCustomerData(customer);
    // eslint-disable-next-line local-rules/set-state-in-use-effect
    updateCache({
      userData: {
        ...customerData,
        loginType: customerData.loginType,
        gender:
          customerData.gender === 'male'
            ? UserGenders.Male
            : UserGenders.Female,
      },
    });
  }, [customer]);
  return null;
};

const useCheckoutCustomerData = () => {
  const userToken = useUserToken();

  const request = useLegacyGrpcRequest(
    CheckoutV1_getCustomerLazy,
    {
      checkoutSession: null,
      session: {
        authToken: userToken!,
      },
    },
    {
      disabled: !userToken,
    },
  );

  return request;
};
